import * as THREE from 'three';

const _matrix = new THREE.Matrix4();
const _pos = new THREE.Vector3();
const _box = new THREE.Box3();
const _sphere = new THREE.Sphere();

/** Bounding sphere from instance matrices so frustum culling stays correct. */
export function fitInstancedMeshBounds(mesh) {
  if (!mesh?.isInstancedMesh) return;
  const n = mesh.count || 0;
  if (n <= 0) {
    mesh.frustumCulled = false;
    return;
  }
  _box.makeEmpty();
  for (let i = 0; i < n; i += 1) {
    mesh.getMatrixAt(i, _matrix);
    _pos.setFromMatrixPosition(_matrix);
    _box.expandByPoint(_pos);
  }
  if (_box.isEmpty()) {
    mesh.frustumCulled = false;
    return;
  }
  _box.getBoundingSphere(_sphere);
  _sphere.radius = Math.max(_sphere.radius, 1);
  mesh.boundingSphere = _sphere.clone();
  mesh.frustumCulled = true;
}
